/**
 * Middleware to redirect requests to urls ending with a trailing slash ('/') to its non-trailing slash equivalent.
 * This is important to reduce duplicate content issues and improve crawling capacities.
 *
 * @param route
 * @param redirect
 */
export default function ({ route, redirect }) {
    if (route.path !== '/' && route.path.endsWith('/')) {
        const { path, query, hash } = route;
        const originalPath = path.replace(/\/+$/, '') || '/';
        const originalRoute = { path: originalPath, query, hash };

        redirect(308, originalRoute);
    }
}